import Modal from 'flarum/common/components/Modal';
import app from 'flarum/forum/app';
import LogInModal from 'flarum/forum/components/LogInModal';
import { currentNotice } from '../utils/guestGuard';

/*
 * 游客点击帖子时弹出的提示（PC 端；手机端走 components/GuestNoticeLayer.js）。
 *
 * 用核心的 Modal 组件（flarum/common/components/Modal）：
 * 遮罩、ESC 关闭、点击外部关闭都自带，不需要自己实现。
 *
 * 【1.7.0】关闭时不再跳转页面：
 * 点击列表里的帖子现在是「原地弹窗」，页面不动；
 * 直接访问 /d/xxx 时页面停在原地址，由 DiscussionLock 显示锁定卡片。
 *
 * 【1.8.36.4】底部按钮改成「注册 / 登录」（1.7.0~1.8.36.3 只有一个「我知道了」）。
 * 访客看完提示最常见的下一步就是去登录，所以给一个直达入口；
 * 原来的「我知道了」降级为次要按钮保留，不想登录的人照样能关掉。
 *
 * 【关于"跳转到登录界面"】Flarum 没有独立的 /login 页面，登录统一是弹窗
 * LogInModal（站内注册/登录都在里面，我们的微信登录、手机短信登录按钮
 * 也挂在它上面），所以这里 show(LogInModal) 就是"打开登录界面"。
 * 手机上核心 Modal 会被媒体查询拉到接近整屏，视觉上就是一整页登录。
 */
export default class GuestNoticeModal extends Modal {
  className() {
    return 'Modal Modal--small AcmeGuestNotice';
  }

  title() {
    return '暂时无法查看帖子内容';
  }

  content() {
    return [
      <div className="Modal-body">
        <p className="AcmeGuestNotice-text">{currentNotice()}</p>
      </div>,
      <div className="Modal-footer">
        <button type="button" className="Button AcmeGuestNotice-ok" onclick={() => this.close()}>
          我知道了
        </button>
        <button type="button" className="Button Button--primary AcmeGuestNotice-login" onclick={() => this.goLogin()}>
          注册 / 登录
        </button>
      </div>,
    ];
  }

  close() {
    this.hide();
  }

  /*
   * 关掉提示再拉起登录弹窗。
   *
   * 【为什么要 setTimeout】核心 Modal 的 hide() 是 300ms 淡出动画，
   * 立刻 show 下一个会和它同时挂在 ModalManager 上（两个弹窗叠一起，
   * 遮罩 / 焦点陷阱互相打架）。等淡出结束再 show，两个弹窗就是先后关系。
   */
  goLogin() {
    this.hide();

    setTimeout(() => {
      try {
        app.modal.show(LogInModal);
        return;
      } catch (e) {
        // ignore
      }

      try {
        window.location.href = '/';
      } catch (e2) {
        // ignore
      }
    }, 350);
  }
}
